class HeaderScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const element = '.js-header';
    if(!isMobile()){
      // ヘッダーメニューをスクロールで表示・非表示
      let elementClass = $(element).attr('class');
      let elementHtml = $(element).html();
      let newElement = $('<div class="is-ready"></div>').addClass(elementClass).html(elementHtml);
      $(element).after(newElement);
    }
    const isUp = (function() {
      const scrollElement = document.scrollingElement;
      let flag, prePoint, scrollPoint;
      return function() {
        scrollPoint = scrollElement.scrollTop;
        flag = prePoint > scrollPoint ? true : false;
        prePoint = scrollPoint;
        return flag;
      }
    }());

    if($('.js-header').hasClass('non-scroll')){

    }else{
      window.addEventListener('scroll', function() {
        if(isMobile()){
          if (window.pageYOffset >= 300) {
            $(element).addClass('is-active').addClass('is-ready');
          }else{
            $(element).removeClass('is-active').removeClass('is-ready');
          }
        }else{
          if (window.pageYOffset >= 300) {
            $(element).next('.is-ready').addClass('is-active');
          }
          if(isUp()){
            $(element).next('.is-ready').removeClass('is-active');
          }
        }
      });
    }

    // スマホヘッダーメニューの開閉
    $(function(){
      let spToggle = '.js-sp-gm-toggle';
      let spNav ='.js-sp-nav';
      let headerWrap = '.js-header';
      $(spToggle).on('click',function(){
        $(spNav).slideToggle();
        $(headerWrap).toggleClass('is-toggle-active');
        if($(headerWrap).hasClass('is-scroll-active')){

        }else{
          // $(headerWrap).toggleClass('is-active');
        }
      })
    })
  }
}